// src/components/tableros/tabs/GeneralTab.js
import React from 'react';
import {
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  Stack,
  Divider,
  Box,
  Alert
} from '@mui/material';
import {
  OpenInNew as OpenInNewIcon,
  RestartAlt as RestartAltIcon
} from '@mui/icons-material';

const GeneralTab = ({
  tableWidth,
  setTableWidth,
  tableHeight,
  setTableHeight,
  displayRows,
  handleDisplayRowsChange,
  stopwatchSize,
  setStopwatchSize,
  largeStopwatchSize,
  setLargeStopwatchSize,
  timerColor,
  resetToDefault,
  openCurrentTablero,
  isMobile,
  boardType,  
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={{ p: 2, height: '100%', minHeight: 320 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Dimensiones del Tablero
          </Typography>
          <Stack spacing={3}>
            <TextField
              label="Filas Visibles"
              type="number"
              value={displayRows}
              onChange={handleDisplayRowsChange}
              variant="outlined"
              size="small"
              inputProps={{ min: 1 }}
              fullWidth
            />
            <TextField
              label="Ancho (px)"
              type="number"
              value={tableWidth}
              onChange={(e) => setTableWidth(parseInt(e.target.value) || 0)}
              variant="outlined"
              size="small"
              inputProps={{ min: 100 }}
              fullWidth
            />
            <TextField
              label="Altura (px)"
              type="number"
              value={tableHeight}
              onChange={(e) => setTableHeight(parseInt(e.target.value) || 0)}
              variant="outlined"
              size="small"
              inputProps={{ min: 100 }}
              fullWidth
            />
          </Stack>
        </Paper>
      </Grid>

      <Grid item xs={12} md={8}>
        <Paper variant="outlined" sx={{ p: 2, height: '100%', minHeight: 320 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Tamaños de Cronómetro
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Tamaño Cronómetro en Encabezado (px)"
                type="number"
                value={stopwatchSize}
                onChange={(e) => setStopwatchSize(parseInt(e.target.value) || 0)}
                variant="outlined"
                size="small"
                inputProps={{ min: 10 }}
                fullWidth
                sx={{ mb: 2 }}
              />
              <Box sx={{ 
                p: 2, 
                backgroundColor: 'rgba(0, 0, 0, 0.1)', 
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    fontSize: `${stopwatchSize}px`,
                    color: timerColor,
                    fontWeight: 'bold'
                  }}
                >
                  00:00
                </Typography>
              </Box>
            </Grid>
            {boardType === 'track' && (
            <Grid item xs={12} sm={12}>
              <TextField
                label="Tamaño Cronómetro Grande (px)"
                type="number"
                value={largeStopwatchSize}
                onChange={(e) => setLargeStopwatchSize(parseInt(e.target.value) || 0)}
                variant="outlined"
                size="small"
                inputProps={{ min: 10 }}
                fullWidth
                sx={{ mb: 2 }}
              />
              <Box sx={{ 
                p: 2, 
                backgroundColor: 'rgba(0, 0, 0, 0.1)', 
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Typography 
                  variant="h2" 
                  sx={{ 
                    fontSize: `${largeStopwatchSize}px`,
                    color: timerColor,
                    fontWeight: 'bold'
                  }}
                >
                  00:00
                </Typography>
              </Box>
            </Grid>
             )}
          </Grid>
          
          <Divider sx={{ my: 2 }} />
          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            <Button
              variant="contained"
              color="primary"
              startIcon={<OpenInNewIcon />}
              onClick={openCurrentTablero}
              sx={{ mb: 2 }}
            >
              Abrir Tablero
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<RestartAltIcon />}
              onClick={resetToDefault}
              sx={{ mb: 2 }}
            >
              Restaurar Valores
            </Button>
          </Stack>
          
          <Divider sx={{ my: 2 }} />
          
          <Box sx={{ mt: 4, p: 2, backgroundColor: 'rgba(0, 0, 0, 0.03)', borderRadius: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              Vista Previa del Tamaño
            </Typography>
            <Box sx={{ 
              width: '100%', 
              height: '120px', 
              border: '2px dashed #ccc', 
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <Box sx={{
                position: 'absolute',
                width: `${Math.min(100, (tableWidth / 1200) * 100)}%`,
                height: `${Math.min(100, (tableHeight / 800) * 100)}%`,
                backgroundColor: 'rgba(25, 118, 210, 0.2)',
                border: '2px solid #1976d2',
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Typography variant="caption" fontWeight="bold">
                  {tableWidth} × {tableHeight} px
                </Typography>
              </Box>
            </Box>
          </Box>
          
          <Alert severity="info" sx={{ mt: 2 }}>
            Los cambios se guardan automáticamente y se aplicarán al abrir un nuevo tablero.
          </Alert>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default GeneralTab;